var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"header__icon-store header__icon",attrs:{"to":"/cua-hang.html","tag":"div","aria-label":"Hệ thống cửa hàng"}},[_c('span',[_vm._v("Cửa hàng")])])}
var staticRenderFns = []

export { render, staticRenderFns }